import React from 'react'
import SpeakerHeader from './SpeakerHeader'
import SpeakerHero from './SpeakerHero'
import SpeakerSection from './SpeakerSection'

export default function SpeakerPage() {
    
  return (
    <>
        
        <SpeakerHero/>
        <SpeakerSection/>
        
    </>
  )
}
